module.exports = __webpack_public_path__ + "img/blogpost5.92dda2ad.jpg";